import { useTranslation } from 'react-i18next';

/**
 * Each way's mark, drawn: a plane, a train, a bus, a ship, a car; a way not planned a dotted
 * line, a change of planes two arrows. Stroked in the text's colour, 24 units square.
 */
/** A way not planned: a dotted line. */
const TRAVEL = 'M3 12h2M9 12h2M15 12h2M21 12h0';

const PATHS: Record<string, string> = {
  // After Lucide's plane (ISC licence).
  flight:
    'M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z',
  train:
    'M7 3h10a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM4 11h16M12 3v8M8 15h.01M16 15h.01M8 18l-2 3M16 18l2 3',
  bus: 'M6 3h12a2 2 0 0 1 2 2v12H4V5a2 2 0 0 1 2-2zM4 11h16M7 17v3M17 17v3M7.5 14h.01M16.5 14h.01M2 8v3M22 8v3',
  ferry: 'M2 20c2 1.3 4 1.3 6 0s4-1.3 6 0 4 1.3 6 0M4 17l-1-5h18l-1 5M6 12V8h12v4M12 4v4',
  car: 'M5 11l1.6-4.4A2 2 0 0 1 8.5 5h7a2 2 0 0 1 1.9 1.6L19 11M3 11h18v6H3zM6 17v2M18 17v2M7 14h.01M17 14h.01',
  // After Lucide's plane-landing (ISC licence): a way that arrives the day after it left.
  arrival:
    'M2 22h20M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z',
  change: 'M4 8h13l-3-3M20 16H7l3 3',
  travel: TRAVEL,
  // After Lucide's tram-front (ISC licence): a metro and a tram in a town; a taxi is a car.
  metro:
    'M8 3h8a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM5 10h14M9 7h6M9 14h.01M15 14h.01M8 21l1-3M16 21l-1-3',
  tram: 'M4 4h16M12 4v3M7 7h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2zM5 12h14M8 15h.01M16 15h.01M8 21l1-3M16 21l-1-3',
  taxi: 'M5 11l1.6-4.4A2 2 0 0 1 8.5 5h7a2 2 0 0 1 1.9 1.6L19 11M3 11h18v6H3zM6 17v2M18 17v2M7 14h.01M17 14h.01M10 5V3h4v2',
  // A town's own ways, drawn as Lucide draws such things (ISC licence).
  bike: 'M5.5 17.5a3.5 3.5 0 1 0 0-.01M18.5 17.5a3.5 3.5 0 1 0 0-.01M15 6h-2l-3 8.5M5.5 17.5 9 10h7l2.5 7.5M12 10l-2-4',
  scooter: 'M5 18a2 2 0 1 0 0-.01M19 18a2 2 0 1 0 0-.01M7 18h10M15 18 12 5h3M5 16l3-4h4',
  cyclo: 'M5 18a3 3 0 1 0 0-.01M19 18a3 3 0 1 0 0-.01M3 13h8l2-6h4M8 18h8M11 13l3 5M17 7l2 11',
  cable:
    'M2 4l20 4M12 6v4M7 10h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1zM6 14h12',
  minibus: 'M4 6h12l4 5v6H4zM4 11h16M8 17a2 2 0 1 0 0-.01M16 17a2 2 0 1 0 0-.01M10 6v5M14 6v5',
  jeepney: 'M3 8h14l3 4v4H3zM3 12h17M6 4h10l1 4M7 18a2 2 0 1 0 0-.01M16 18a2 2 0 1 0 0-.01',
  songthaew: 'M2 7h11v9H2zM13 10h5l3 3v3h-8M2 11h11M6 19a2 2 0 1 0 0-.01M17 19a2 2 0 1 0 0-.01',
  tuktuk: 'M3 15V9a3 3 0 0 1 3-3h8l4 5v4zM3 11h15M7 18a2 2 0 1 0 0-.01M17 18a2 2 0 1 0 0-.01',
  motortaxi: 'M5 17a3 3 0 1 0 0-.01M19 17a3 3 0 1 0 0-.01M8 17h6l3-6h-4l-2-3H8M15 11l2-3h2',
  ridehail:
    'M5 11l1.6-4.4A2 2 0 0 1 8.5 5h7a2 2 0 0 1 1.9 1.6L19 11M3 11h18v6H3zM6 17v2M18 17v2M10 14h4M17 2l2 2-2 2',
  boat: 'M2 18c2 1.3 4 1.3 6 0s4-1.3 6 0 4 1.3 6 0M4 15l2-5h12l2 5M12 10V4l4 3',
  // After Lucide's bed (ISC licence): a night's room.
  stay: 'M2 4v16M2 8h18a2 2 0 0 1 2 2v10M2 17h20M6 8v9',
  // Each kind of place a stay is, drawn as Lucide draws such things (ISC licence).
  hotel:
    'M3 21h18M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16M9 7h1M14 7h1M9 11h1M14 11h1M10 21v-4h4v4',
  hostel: 'M3 3v18M21 3v18M3 10h18M3 18h18M6 7h5M6 15h5',
  apartment: 'M3 21h18M6 21V3h12v18M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2',
  guesthouse: 'M3 10l9-7 9 7v11H3zM9 21v-6h6v6',
  bnb: 'M17 8h1a4 4 0 1 1 0 8h-1M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4ZM6 2v2M10 2v2M14 2v2',
  resort:
    'M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14',
  villa: 'M2 12 12 4l10 8M4 10v11h16V10M10 21v-5h4v5M15 13h2',
  house: 'M3 10l9-7 9 7v11H3zM9 13h6',
  ryokan: 'M3 5h18M5 9h14M7 5v16M17 5v16M12 9v3',
  capsule: 'M4 9a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM8 14h8',
  camping: 'M3.5 21 14 3M20.5 21 10 3M15.5 21 12 15l-3.5 6M2 21h20',
  homestay:
    'M3 10l9-7 9 7v11H3zM12 18s-3-1.8-3-3.6a1.6 1.6 0 0 1 3-.8 1.6 1.6 0 0 1 3 .8c0 1.8-3 3.6-3 3.6z',
  // After Lucide's footprints (ISC licence): a way on foot.
  walk: 'M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0ZM20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0ZM16 17h4M4 13h4',
  // A trail walked over days: the same footprints.
  foot: 'M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0ZM20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0ZM16 17h4M4 13h4',
};

/** A mark's path, 24 units square: a way's, a room's by its kind; a way unknown, dotted. */
export function markPath(mode: string | null | undefined): string {
  return PATHS[mode ?? 'travel'] ?? TRAVEL;
}

/** A way's mark, `size` pixels square, hidden from screen readers: its word is said beside it. */
export function ModeIcon({
  mode,
  size = 14,
}: {
  mode: string | null | undefined;
  size?: number;
}) {
  return (
    <svg
      className="mode-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={markPath(mode)} />
    </svg>
  );
}

/** A change on the way, its two arrows; the word is kept for screen readers and said on hover. */
export function ChangeMark({ size = 14, label }: { size?: number; label?: string }) {
  const { t } = useTranslation();
  const said = label ?? t('plan.transferShort');
  return (
    <span className="change-mark" title={said}>
      <ModeIcon mode="change" size={size} />
      <span className="visually-hidden">{said}</span>
    </span>
  );
}
